import { useState, useEffect, useRef } from "react";
import Header from "../../commons/header/header";
import Footer from "../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
} from "@mui/material";
import "./gallery.css";
import ACTIVITY10 from "../../../assests/images/ACTIVITY10.jpeg";
import ACTIVITY11 from "../../../assests/images/ACTIVITY11.jpeg";
import ACTIVITY12 from "../../../assests/images/ACTIVITY12.jpeg";
import ACTIVITY13 from "../../../assests/images/ACTIVITY13.jpeg";
import ACTIVITY14 from "../../../assests/images/ACTIVITY14.jpeg";
import ACTIVITY15 from "../../../assests/images/ACTIVITY15.jpeg";
import ACTIVITY16 from "../../../assests/images/ACTIVITY16.jpeg";
import ACTIVITY17 from "../../../assests/images/ACTIVITY17.jpeg";
import ACTIVITY18 from "../../../assests/images/ACTIVITY18.jpeg";
import ACTIVITY19 from "../../../assests/images/ACTIVITY19.jpeg";
import ACTIVITY20 from "../../../assests/images/ACTIVITY20.jpeg";
import ACTIVITY21 from "../../../assests/images/ACTIVITY21.jpeg";
import ACTIVITY22 from "../../../assests/images/ACTIVITY22.jpeg";
import ACTIVITY23 from "../../../assests/images/ACTIVITY23.jpeg";
import ACTIVITY24 from "../../../assests/images/ACTIVITY24.jpeg";
import ACTIVITY25 from "../../../assests/images/ACTIVITY25.jpeg";
import ACTIVITY26 from "../../../assests/images/ACTIVITY26.jpeg";
import ACTIVITY27 from "../../../assests/images/ACTIVITY27.jpeg";
import ACTIVITY28 from "../../../assests/images/ACTIVITY28.jpeg";
import ACTIVITY29 from "../../../assests/images/ACTIVITY29.jpeg";
import ACTIVITY30 from "../../../assests/images/ACTIVITY30.jpeg";
import ACTIVITY31 from "../../../assests/images/ACTIVITY31.jpeg";
import ACTIVITY32 from "../../../assests/images/ACTIVITY32.jpeg";
import ACTIVITY33 from "../../../assests/images/ACTIVITY33.jpeg";
import ACTIVITY34 from "../../../assests/images/ACTIVITY34.jpeg";
import ACTIVITY35 from "../../../assests/images/ACTIVITY35.jpeg";
import ACTIVITY36 from "../../../assests/images/ACTIVITY36.jpeg";
import ACTIVITY37 from "../../../assests/images/ACTIVITY37.jpeg";
import ACTIVITY38 from "../../../assests/images/ACTIVITY38.jpeg";
import AGRI_BG from "../../../assests/images/agri-bg.jpeg";
import BG from "../../../assests/images/agri-bg.jpg";
import SPORTS1 from "../../../assests/images/SPORTS1.png";
import SPORTS2 from "../../../assests/images/SPORTS2.png";
import SPORTS3 from "../../../assests/images/SPORTS3.jpeg";
import SPORTS4 from "../../../assests/images/SPORTS4.jpeg";
import SPORTS5 from "../../../assests/images/SPORTS4.jpeg";
import SPORTS6 from "../../../assests/images/SPORTS5.jpeg";
import SPORTS7 from "../../../assests/images/SPORTS6.jpeg";
import SPORTS8 from "../../../assests/images/SPORTS7.jpeg";
import SPORTS9 from "../../../assests/images/SPORTS8.jpeg";
import SPORTS10 from "../../../assests/images/SPORTS9.jpeg";
import SPORTS11 from "../../../assests/images/SPORTS10.jpeg";
import SPORTS12 from "../../../assests/images/SPORTS11.jpeg";
import SPORTS13 from "../../../assests/images/SPORTS12.jpeg";
import SPORTS14 from "../../../assests/images/SPORTS13.jpeg";
import SPORTS15 from "../../../assests/images/SPORTS14.jpeg";
import SPORTS16 from "../../../assests/images/SPORTS15.jpeg";
import SPORTS17 from "../../../assests/images/SPORTS16.jpeg";
import SPORTS18 from "../../../assests/images/SPORTS17.jpeg";
import IMAGE4 from "../../../assests/images/4.png";
import PROGRAM1 from "../../../assests/images/PROGRAM1.png";
import ACTIVITY1 from "../../../assests/images/ACTIVITY1.png";
import PROGRAM2 from "../../../assests/images/PROGRAM2.png";
import PROGRAM3 from "../../../assests/images/PROGRAM3.png";
import PROGRAM4 from "../../../assests/images/PROGRAM4.png";
import PROGRAM5 from "../../../assests/images/PROGRAM5.png";
import PROGRAM6 from "../../../assests/images/PROGRAM6.png";
import PROGRAM7 from "../../../assests/images/PROGRAM7.png";
import PROGRAM8 from "../../../assests/images/PROGRAM8.png";
import PROGRAM9 from "../../../assests/images/PROGRAM9.png";
import ACTIVITY4 from "../../../assests/images/ACTIVITY4.jpeg";
import IMAGE_N1 from "../../../assests/images/IMAGE-1.jpeg";
import IMAGE_N2 from "../../../assests/images/IMAGE-2.jpeg";
import ACTIVITY5 from "../../../assests/images/ACTIVITY5.jpeg";
import ACTIVITY6 from "../../../assests/images/ACTIVITY6.jpeg";
import ACTIVITY7 from "../../../assests/images/ACTIVITY7.jpeg";
import ACTIVITY8 from "../../../assests/images/ACTIVITY8.jpeg";
import ACTIVITY9 from "../../../assests/images/ACTIVITY9.jpeg";
import ACTIVITY5_DUP from "../../../assests/images/ACTIVITY5.jpeg";
import ACTIVITY1_PNG from "../../../assests/images/ACTIVITY1.png";
import ACTIVITY2 from "../../../assests/images/ACTIVITY2.jpeg";
import ACTIVITY3 from "../../../assests/images/ACTIVITY3.jpeg";
import ACTIVITY4_DUP from "../../../assests/images/ACTIVITY4.jpeg";
import NSS_MOTTO from "../../../assests/images/NSS_MOTTO.jpg";
import VIDEO1 from "../../../assests/video/SPORTS.mp4";

// Sports members data
const sportsMembers = [
  { id: 1, name: "Dr. P. Eswaramoorthi", designation: "Principal", category: "Chairperson" },
  { id: 2, name: "Mr. S. Dhivakaran", designation: "Associate Professor / MECH", category: "Event Co-ordinator" },
  { id: 3, name: "Mr. K. Saravanakumar", designation: "Assistant Professor / EEE", category: "Internal Member" },
  { id: 4, name: "Mr. Faizal Rahman", designation: "Associate Professor, HOD / S&H", category: "Internal Member" },
  { id: 5, name: "Mr. M. S. Praveen", designation: "Assistant Professor, HOD / MECH", category: "Internal Member" },
  { id: 6, name: "Mr. D. Senthil Babu", designation: "Assistant Professor, HOD / BME", category: "Internal Member" },
  { id: 7, name: "Mrs. S. Maheswari", designation: "Assistant Professor, HOD / CSE", category: "Internal Member" },
  { id: 8, name: "Mr. S. Sanjay", designation: "Student Representative", category: "Student" },
  { id: 9, name: "Mr. C. Ragunath", designation: "Student Representative", category: "Student" },
  { id: 10, name: "Ms. Susmiths", designation: "Student Representative", category: "Student" },
];

// Assign categories and types based on file names
const images = [
  { src: ACTIVITY10, alt: "Activity 10", category: "Activity", type: "image" },
  { src: ACTIVITY11, alt: "Activity 11", category: "Activity", type: "image" },
  { src: ACTIVITY12, alt: "Activity 12", category: "Activity", type: "image" },
  { src: ACTIVITY13, alt: "Activity 13", category: "Activity", type: "image" },
  { src: ACTIVITY14, alt: "Activity 14", category: "Activity", type: "image" },
  { src: ACTIVITY15, alt: "Activity 15", category: "Activity", type: "image" },
  { src: ACTIVITY16, alt: "Activity 16", category: "Activity", type: "image" },
  { src: ACTIVITY17, alt: "Activity 17", category: "Activity", type: "image" },
  { src: ACTIVITY18, alt: "Activity 18", category: "Activity", type: "image" },
  { src: ACTIVITY19, alt: "Activity 19", category: "Activity", type: "image" },
  { src: ACTIVITY20, alt: "Activity 20", category: "Activity", type: "image" },
  { src: ACTIVITY21, alt: "Activity 21", category: "Activity", type: "image" },
  { src: ACTIVITY22, alt: "Activity 22", category: "Activity", type: "image" },
  { src: ACTIVITY23, alt: "Activity 23", category: "Activity", type: "image" },
  { src: ACTIVITY24, alt: "Activity 24", category: "Activity", type: "image" },
  { src: ACTIVITY25, alt: "Activity 25", category: "Activity", type: "image" },
  { src: ACTIVITY26, alt: "Activity 26", category: "Activity", type: "image" },
  { src: ACTIVITY27, alt: "Activity 27", category: "Activity", type: "image" },
  { src: ACTIVITY28, alt: "Activity 28", category: "Activity", type: "image" },
  { src: ACTIVITY29, alt: "Activity 29", category: "Activity", type: "image" },
  { src: ACTIVITY30, alt: "Activity 30", category: "Activity", type: "image" },
  { src: ACTIVITY31, alt: "Activity 31", category: "Activity", type: "image" },
  { src: ACTIVITY32, alt: "Activity 32", category: "Activity", type: "image" },
  { src: ACTIVITY33, alt: "Activity 33", category: "Activity", type: "image" },
  { src: ACTIVITY34, alt: "Activity 34", category: "Activity", type: "image" },
  { src: ACTIVITY35, alt: "Activity 35", category: "Activity", type: "image" },
  { src: ACTIVITY36, alt: "Activity 36", category: "Activity", type: "image" },
  { src: ACTIVITY37, alt: "Activity 37", category: "Activity", type: "image" },
  { src: ACTIVITY38, alt: "Activity 38", category: "Activity", type: "image" },
  { src: AGRI_BG, alt: "Agricultural Background", category: "Programs", type: "image" },
  { src: SPORTS1, alt: "Sports 1", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS2, alt: "Sports 2", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS3, alt: "Sports 3", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS4, alt: "Sports 4", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS5, alt: "Sports 5", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS6, alt: "Sports 6", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS7, alt: "Sports 7", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS8, alt: "Sports 8", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS9, alt: "Sports 9", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS10, alt: "Sports 10", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS11, alt: "Sports 11", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS12, alt: "Sports 12", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS13, alt: "Sports 13", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS14, alt: "Sports 14", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS15, alt: "Sports 15", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS16, alt: "Sports 16", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS17, alt: "Sports 17", category: "Sports", subcategory: "Photos", type: "image" },
  { src: SPORTS18, alt: "Sports 18", category: "Sports", subcategory: "Photos", type: "image" },
  { src: VIDEO1, alt: "Sports Video 1", category: "Sports", subcategory: "Videos", type: "video" },
  { src: IMAGE4, alt: "Image 4", category: "Programs", type: "image" },
  { src: PROGRAM1, alt: "Program 1", category: "Programs", type: "image" },
  { src: ACTIVITY1, alt: "Activity 1", category: "Activity", type: "image" },
  { src: PROGRAM2, alt: "Program 2", category: "Programs", type: "image" },
  { src: PROGRAM3, alt: "Program 3", category: "Programs", type: "image" },
  { src: PROGRAM4, alt: "Program 4", category: "Programs", type: "image" },
  { src: PROGRAM5, alt: "Program 5", category: "Programs", type: "image" },
  { src: PROGRAM6, alt: "Program 6", category: "Programs", type: "image" },
  { src: PROGRAM7, alt: "Program 7", category: "Programs", type: "image" },
  { src: PROGRAM8, alt: "Program 8", category: "Programs", type: "image" },
  { src: PROGRAM9, alt: "Program 9", category: "Programs", type: "image" },
  { src: ACTIVITY4, alt: "Activity 4", category: "Activity", type: "image" },
  { src: IMAGE_N1, alt: "Image N1", category: "Programs", type: "image" },
  { src: IMAGE_N2, alt: "Image N2", category: "Programs", type: "image" },
  { src: ACTIVITY5, alt: "Activity 5", category: "Activity", type: "image" },
  { src: ACTIVITY6, alt: "Activity 6", category: "Activity", type: "image" },
  { src: ACTIVITY7, alt: "Activity 7", category: "Activity", type: "image" },
  { src: ACTIVITY8, alt: "Activity 8", category: "Activity", type: "image" },
  { src: ACTIVITY9, alt: "Activity 9", category: "Activity", type: "image" },
  { src: ACTIVITY5_DUP, alt: "Activity 5 Duplicate", category: "Activity", type: "image" },
  { src: ACTIVITY1_PNG, alt: "Activity 1 PNG", category: "Activity", type: "image" },
  { src: ACTIVITY2, alt: "Activity 2", category: "Activity", type: "image" },
  { src: ACTIVITY3, alt: "Activity 3", category: "Activity", type: "image" },
  { src: ACTIVITY4_DUP, alt: "Activity 4 Duplicate", category: "Activity", type: "image" },
  { src: NSS_MOTTO, alt: "Motto of NSS", category: "NSS", type: "image" },
];

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("All Events");
  const [selectedSportsTab, setSelectedSportsTab] = useState("Photos");
  const [zoomedMedia, setZoomedMedia] = useState(null);
  const zoomModalRef = useRef(null);

  // Function to handle category button click
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category === "Sports") {
      setSelectedSportsTab("Photos"); // Default to Photos when Sports is selected
    }
  };

  // Handle NSS Activity (open PDF)
  const handleNSSActivity = () => {
    window.open(`${process.env.PUBLIC_URL}/pdf/NSS_ACTIVITY.pdf`, "_blank");
    setSelectedCategory("All Events"); // Reset to All Events after opening PDF
  };

  // Handle Motto of NSS (display image)
  const handleNSSMotto = () => {
    setSelectedCategory("NSS");
  };

  // Handle sports subsection click
  const handleSportsTabChange = (tab) => {
    setSelectedSportsTab(tab);
    if (tab === "Facilities") {
      window.open(`${process.env.PUBLIC_URL}/pdf/sports_facilities.pdf`, "_blank");
    } else if (tab === "Ground") {
      window.open(`${process.env.PUBLIC_URL}/pdf/sports_ground.pdf`, "_blank");
    } else if (tab === "Achievements") {
      window.open(`${process.env.PUBLIC_URL}/pdf/sports_achievement.pdf`, "_blank");
    }
  };

  // Handle media click to zoom
  const handleMediaClick = (media) => {
    setZoomedMedia(media);
  };

  // Close zoomed media
  const closeZoom = () => {
    setZoomedMedia(null);
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (zoomModalRef.current && !zoomModalRef.current.contains(event.target)) {
        closeZoom();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Filter media based on selected category and sports tab
  const filteredMedia =
    selectedCategory === "All Events"
      ? images.filter((media) => media.category !== "NSS") // Exclude NSS Motto from All Events
      : selectedCategory === "Sports"
      ? images.filter(
          (media) => media.category === "Sports" && media.subcategory === selectedSportsTab
        )
      : images.filter((media) => media.category === selectedCategory);

  return (
    <>
      <Header />
      <div className="image-section">
        <img src={BG} alt="Gallery" className="department-image" />
        <div className="overlay-text">Gallery</div>
      </div>
      <div className="gallery-menu">
        <Button
          variant={selectedCategory === "All Events" ? "contained" : "outlined"}
          onClick={() => handleCategoryChange("All Events")}
          style={{
            width: "100%",
            maxWidth: "200px",
            color: selectedCategory === "All Events" ? "#FFF" : "#000",
            borderColor: selectedCategory === "All Events" ? "#FFF" : "#80deea",
            borderWidth: "2px",
          }}
        >
          All Events
        </Button>
        <Button
          variant={selectedCategory === "Sports" ? "contained" : "outlined"}
          onClick={() => handleCategoryChange("Sports")}
          style={{
            width: "100%",
            maxWidth: "200px",
            color: selectedCategory === "Sports" ? "#FFF" : "#000",
            borderColor: selectedCategory === "Sports" ? "#FFF" : "#80deea",
            borderWidth: "2px",
          }}
        >
          Sports
        </Button>
        <Button
          variant={selectedCategory === "Activity" ? "contained" : "outlined"}
          onClick={() => handleCategoryChange("Activity")}
          style={{
            width: "100%",
            maxWidth: "200px",
            color: selectedCategory === "Activity" ? "#FFF" : "#000",
            borderColor: selectedCategory === "Activity" ? "#FFF" : "#80deea",
            borderWidth: "2px",
          }}
        >
          Activity
        </Button>
        <Button
          variant={selectedCategory === "Programs" ? "contained" : "outlined"}
          onClick={() => handleCategoryChange("Programs")}
          style={{
            width: "100%",
            maxWidth: "200px",
            color: selectedCategory === "Programs" ? "#FFF" : "#000",
            borderColor: selectedCategory === "Programs" ? "#FFF" : "#80deea",
            borderWidth: "2px",
          }}
        >
          Programs
        </Button>
        <Button
          variant={selectedCategory === "NSS Activity" ? "contained" : "outlined"}
          onClick={handleNSSActivity}
          style={{
            width: "100%",
            maxWidth: "200px",
            color: selectedCategory === "NSS Activity" ? "#FFF" : "#000",
            borderColor: selectedCategory === "NSS Activity" ? "#FFF" : "#80deea",
            borderWidth: "2px",
          }}
        >
          NSS Activity
        </Button>
        <Button
          variant={selectedCategory === "NSS" ? "contained" : "outlined"}
          onClick={handleNSSMotto}
          style={{
            width: "100%",
            maxWidth: "200px",
            color: selectedCategory === "NSS" ? "#FFF" : "#000",
            borderColor: selectedCategory === "NSS" ? "#FFF" : "#80deea",
            borderWidth: "2px",
          }}
        >
          Motto of NSS
        </Button>
      </div>
      {selectedCategory === "Sports" && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={1}
          flexWrap="wrap"
          mb={2}
        >
          <Button
            variant={selectedSportsTab === "Members" ? "contained" : "outlined"}
            onClick={() => handleSportsTabChange("Members")}
            style={{
              width: "100%",
              maxWidth: "150px",
              color: selectedSportsTab === "Members" ? "#FFF" : "#000",
              borderColor: selectedSportsTab === "Members" ? "#FFF" : "#80deea",
              borderWidth: "2px",
            }}
          >
            Members
          </Button>
          <Button
            variant={selectedSportsTab === "Facilities" ? "contained" : "outlined"}
            onClick={() => handleSportsTabChange("Facilities")}
            style={{
              width: "100%",
              maxWidth: "150px",
              color: selectedSportsTab === "Facilities" ? "#FFF" : "#000",
              borderColor: selectedSportsTab === "Facilities" ? "#FFF" : "#80deea",
              borderWidth: "2px",
            }}
          >
            Facilities
          </Button>
          <Button
            variant={selectedSportsTab === "Ground" ? "contained" : "outlined"}
            onClick={() => handleSportsTabChange("Ground")}
            style={{
              width: "100%",
              maxWidth: "150px",
              color: selectedSportsTab === "Ground" ? "#FFF" : "#000",
              borderColor: selectedSportsTab === "Ground" ? "#FFF" : "#80deea",
              borderWidth: "2px",
            }}
          >
            Ground
          </Button>
          <Button
            variant={selectedSportsTab === "Achievements" ? "contained" : "outlined"}
            onClick={() => handleSportsTabChange("Achievements")}
            style={{
              width: "100%",
              maxWidth: "150px",
              color: selectedSportsTab === "Achievements" ? "#FFF" : "#000",
              borderColor: selectedSportsTab === "Achievements" ? "#FFF" : "#80deea",
              borderWidth: "2px",
            }}
          >
            Achievements
          </Button>
          <Button
            variant={selectedSportsTab === "Videos" ? "contained" : "outlined"}
            onClick={() => handleSportsTabChange("Videos")}
            style={{
              width: "100%",
              maxWidth: "150px",
              color: selectedSportsTab === "Videos" ? "#FFF" : "#000",
              borderColor: selectedSportsTab === "Videos" ? "#FFF" : "#80deea",
              borderWidth: "2px",
            }}
          >
            Videos
          </Button>
          <Button
            variant={selectedSportsTab === "Photos" ? "contained" : "outlined"}
            onClick={() => handleSportsTabChange("Photos")}
            style={{
              width: "100%",
              maxWidth: "150px",
              color: selectedSportsTab === "Photos" ? "#FFF" : "#000",
              borderColor: selectedSportsTab === "Photos" ? "#FFF" : "#80deea",
              borderWidth: "2px",
            }}
          >
            Photos
          </Button>
        </Box>
      )}
      {selectedCategory === "Sports" && selectedSportsTab === "Members" ? (
        <Box flex="1" p={2} maxWidth="1400px" margin="0 auto">
          <h2>Sports Committee Members (2024-25)</h2>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{ backgroundColor: "#01366b", color: "white" }}
                  >
                    S.No.
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: "#01366b", color: "white" }}
                  >
                    Name of the Members
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: "#01366b", color: "white" }}
                  >
                    Designation
                  </TableCell>
                  <TableCell
                    sx={{ backgroundColor: "#01366b", color: "white" }}
                  >
                    Category
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sportsMembers.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: index % 2 === 0 ? "white" : "#f1f8e9",
                    }}
                  >
                    <TableCell width={200}>{row.id}</TableCell>
                    <TableCell width={200}>{row.name}</TableCell>
                    <TableCell width={300}>{row.designation}</TableCell>
                    <TableCell width={200}>{row.category}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <div className="gallery-media">
          {filteredMedia.map((media, index) => (
            <div key={index} className="media-container">
              {media.type === "image" ? (
                <img
                  src={media.src}
                  alt={media.alt}
                  className="gallery-image"
                  loading="lazy"
                  onClick={() => handleMediaClick(media)}
                />
              ) : (
                <div className="video-wrapper">
                  <video
                    src={media.src}
                    className="gallery-video"
                    muted
                    loop
                    playsInline
                  />
                  <div className="play-button" onClick={() => handleMediaClick(media)} aria-label="Play video">
                    <span className="play-icon">▶</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {zoomedMedia && (
        <div className="zoom-modal">
          <div className="zoom-modal-content" ref={zoomModalRef}>
            <button className="zoom-close-button" onClick={closeZoom}>
              ×
            </button>
            {zoomedMedia.type === "image" ? (
              <img
                src={zoomedMedia.src}
                alt={zoomedMedia.alt}
                className="zoom-image"
              />
            ) : (
              <video
                src={zoomedMedia.src}
                controls
                autoPlay
                className="zoom-video"
              />
            )}
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Gallery;